import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "textformat-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", transform: "translate(2 4.5)" },
        React.createElement("path", { strokeLinecap: "round", d: "M12.5 8V2" }),
        React.createElement("ellipse", { cx: 10, cy: 5, rx: 2.5, ry: 3 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m0 8 3-8 3 8" }),
        React.createElement("path", { d: "M1.25 5H5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
